import type { FC } from 'react';
import React from 'react';

import { isArticleExists } from '../../helpers/is-article-exists';
import { useArticleDataContext } from '../../components/article-data-provider/context';
import { TITLE_PREFIX } from '../../constants';

import type { TArticle } from './models';

export const ArticleContainer: FC<TArticle> = ({
    LinkCanonical,
    Meta,
    MetaTitle,
    View,
    children,
    className,
}) => {
    const { analytics, article } = useArticleDataContext();
    if (!isArticleExists(article)) {
        return null;
    }

    return (
        <section className={className}>
            <MetaTitle title={`${article.title} ${TITLE_PREFIX}`} />
            <Meta metaData={article.seo} />
            <LinkCanonical url={article.linkCanonicalUri} />
            <View analytics={analytics} article={article}>
                {children}
            </View>
        </section>
    );
};
